import ArbeitspaketSelection from '../../ArbeitspaketSelection/ArbeitspaketSelection'
import Currency from '../../../../UI/Input/Currency'
import DaySelector from '../../../../UI/DaySelector/DaySelector'
import Checkbox from '../../../../UI/Checkbox/Checkbox'
import { OfferEntry } from '../../../../../types/Controlling/OfferEntry'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'

type Props = {
  data: OfferEntry
  set: (key: keyof OfferEntry) => (value: any) => void
}

const EntryMask: React.FC<Props> = ({ data, set }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <div className="flex flex-col gap-2">
      <ArbeitspaketSelection value={data.arbeitspaketUUID} onChange={set('arbeitspaketUUID')} />
      <Currency required value={data.amount} onChange={set('amount')} label={t.controlling.offer.entry.add.amount} />
      <DaySelector required label={t.controlling.offer.entry.add.startDate} value={data.scheduledDate} onChange={set('scheduledDate')} />
      <Checkbox label={t.controlling.offer.entry.add.alreadyAccepted} checked={data.accepted} onChange={set('accepted')} />
    </div>
  )
}

export default EntryMask
